import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Modal, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

type User = {
  _id: string
  userName?: string
  email?: string
  status?: string
  accessLevel?: string
}

export function UserListPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [list, setList] = useState<User[]>([])
  const [deleteId, setDeleteId] = useState<string | null>(null)

  const load = () => {
    void sessionApi.getAllUsers().then((res) => {
      setList(Array.isArray(res.data) ? (res.data as User[]) : [])
    })
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <div>
      <PageHead
        title="Users"
        onBack={() => navigate('/sessionmarket')}
        actions={
          <Link to="/createuser">
            <Button variant="primary">Create User</Button>
          </Link>
        }
      />
      <div className="sm-card">
        <table className="w7-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {list.map((u, i) => (
              <tr key={u._id}>
                <td>{i + 1}</td>
                <td>{u.userName}</td>
                <td>{u.email}</td>
                <td>{u.status}</td>
                <td className="sm-row">
                  <Link to={`/createuser?id=${u._id}`}>
                    <Button size="sm">Edit</Button>
                  </Link>
                  <Button size="sm" variant="danger" onClick={() => setDeleteId(u._id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        title="Delete User"
        footer={
          <Button
            variant="danger"
            onClick={() => {
              if (!deleteId) return
              void sessionApi.deleteOneUser(deleteId).then(() => {
                toast.success('Deleted')
                setDeleteId(null)
                load()
              })
            }}
          >
            Delete
          </Button>
        }
      >
        <p>Delete this user?</p>
      </Modal>
    </div>
  )
}
